// extracted by mini-css-extract-plugin
export default {"icon":"IconHue_icon__r9SyG"};